import { Injectable, TemplateRef } from '@angular/core';
import { SbGenericModalComponent } from './sb-generic-modal.component';
import { filter, Subject } from 'rxjs';

export interface ModalOptions {
    modalTitle: string;
    closeButtonText: string;
    allowTapClose: boolean;
    isStandalone: boolean;
    hasBackdrop?: boolean;
    allowDragResize: boolean;
    size?: 'xs' | 'sm' | 'auto' | 'lg' | 'fullscreen';
    footerActions?: Array<TemplateRef<unknown>>;
    centerModal?: boolean;
    defaultCloseAction?: boolean;
}

export interface ModalTemplateOptions extends ModalOptions {
    templateRef: TemplateRef<unknown>;
    // note; 'center' will apply a class with no effect, but the modal is centered by default,
    position?: 'center' | 'aside-right' | 'aside-left';
}

@Injectable({
    providedIn: 'root'
})
export class SbGenericModalService {
    afterLeaveAnimationSubject$ = new Subject<boolean>();
    afterLeaveAnimation$ = this.afterLeaveAnimationSubject$.pipe(
        filter((hasLeft) => hasLeft)
    );

    currentlyOpenedModal?: SbGenericModalComponent;
    constructor() {}

    setModalOpened(modalComponent: SbGenericModalComponent) {
        this.currentlyOpenedModal = modalComponent;
    }

    dismissOpenedModal() {
        if (this.currentlyOpenedModal) {
            this.currentlyOpenedModal.closeModal();
            // clean up all references
            this.currentlyOpenedModal = null;
        }
    }
}
